// src/services/CompanyService.ts
import { BaseService } from "@services/BaseService";

class CompanyService extends BaseService {
  searchCompanies(companyName: string) {
    return this.get(`/company/search`, {
      params: { company_name: companyName },
    });
  }

  registerUserWithCompany(companyId: number, data: any) {
    return this.post(`/users/registration?company_id=${companyId}`, data);
  }

  registerUserWithNewCompany(data: any) {
    return this.post(`/users/company_registration`, data);
  }

  getCompanyFocusAreas() {
    return this.get(`/company/areas`);
  }

  getCompanyRoles() {
    return this.get(`/company/roles`);
  }

  getCompanyMembers() {
    return this.get(`/company/members`);
  }

  approveUser(userId: number) {
    return this.post(`/company/approve_user`, null, {
      params: { user_id: userId },
    });
  }

  rejectUser(userId: number) {
    return this.post(`/company/reject_user`, null, {
      params: { user_id: userId },
    });
  }

  deleteUser(userId: number) {
    return this.post(`/company/delete_user`, null, {
      params: { user_id: userId },
    });
  }
}

export const companyService = new CompanyService();
